import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import { firebaseConfig } from '../config';
import { getImpersonationSession } from '../../helpers/impersonation';

export const getFirebaseApp = () => {
    const session = getImpersonationSession();
    const local = process.env.FB_EMULATOR === 'true';
    const name = session
        ? `${local ? 'local-' : ''}impersonation-${session}`
        : local
        ? 'local'
        : '[DEFAULT]';
    return (
        firebase.apps.find((app) => app.name === name) ||
        firebase.initializeApp(firebaseConfig, name)
    );
};

const firebaseApi = async () => {
    getFirebaseApp();

    return firebase;
};

export default firebaseApi;
